// Entity display registry. Maps an entity key to its display config (columns →
// slots, views, badges, empty state). A page renders a collection with
// <EntityList entity="admin" rows={admins} />; everything else is derived from here.
//
// Configs SELF-REGISTER: drop a file at lib/entities/<name>.js whose default export
// includes a `key` (the singular entity name pages reference), and it's picked up
// automatically via import.meta.glob — no edits to this file needed.
const modules = import.meta.glob('./*.js', { eager: true })

export const ENTITIES = {}
for (const [path, mod] of Object.entries(modules)) {
  const base = path.slice(2, -3) // './users.js' -> 'users'
  if (base === 'index' || base === 'slots') continue
  const config = mod.default
  if (config?.key) ENTITIES[config.key] = config
}

export function entityFor(key) {
  const config = ENTITIES[key]
  if (!config) throw new Error(`Unknown entity "${key}" — add lib/entities/<name>.js with a matching \`key\` and register it via the entity glob`)
  return config
}

// The view modes an entity supports: table always, grid/board when configured
// (or an explicit `views` list on the config).
export function viewsFor(key) {
  const config = ENTITIES[key]
  if (!config) return ['table']
  if (config.views) return config.views
  const views = ['table']
  if (config.grid) views.push('grid')
  if (config.board) views.push('board')
  return views
}

export { SLOTS } from './slots.js'
